import { createFileRoute } from '@tanstack/react-router';
import { AdminKeywordManagement } from '@/components/tasks/admin-keyword-management';

export const Route = createFileRoute('/_authenticated/_layout/admin/keywords')({
  component: AdminKeywordManagement,
  loader: () => {
    // Add any necessary authentication checks
    return null;
  },
});